export interface Movie {
  id: number;
  title: string;
  englishTitle: string;
  category: string;
  categorySlug: string;
  year: number;
  rating: number;
  duration: string;
  region: string;
  director: string;
  actors: string[];
  description: string;
  tags: string[];
  coverUrl: string;
  isHot: boolean;
  isNew: boolean;
  updateInfo: string;
  episodeTotal: number;
  episodeCurrent: number;
}

export const movies: Movie[] = [
  {
    id: 1,
    title: "流浪地球3",
    englishTitle: "The Wandering Earth 3",
    category: "电影",
    categorySlug: "movie",
    year: 2026,
    rating: 8.5,
    duration: "148分钟",
    region: "中国大陆",
    director: "郭帆",
    actors: ["吴京", "刘德华", "李雪健"],
    description: "太阳急速老化，持续膨胀，将在百年内吞没地球。人类面临前所未有的生存危机，联合政府决定实施「移山计划」，在地球表面建造上万座行星发动机，推动地球离开太阳系，开启长达2500年的星际流浪之旅。在这漫长的旅途中，人类将面对未知的宇宙挑战与内心的抉择。",
    tags: ["科幻", "灾难", "冒险", "硬核科幻"],
    coverUrl: "https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20poster%20of%20Chinese%20sci-fi%20film%20The%20Wandering%20Earth%2C%20featuring%20a%20massive%20planetary%20engine%20against%20a%20dark%20cosmic%20background%20with%20warm%20orange%20glow%2C%20dramatic%20lighting%2C%20epic%20scale%2C%20film%20grain%20texture%2C%20professional%20movie%20poster%20composition%20with%20Chinese%20aesthetic%20elements&width=400&height=560&seq=movie-cover-01&orientation=portrait",
    isHot: true,
    isNew: true,
    updateInfo: "HD高清",
    episodeTotal: 1,
    episodeCurrent: 1,
  },
  {
    id: 2,
    title: "长安三万里",
    englishTitle: "Chang An",
    category: "电影",
    categorySlug: "movie",
    year: 2025,
    rating: 8.8,
    duration: "168分钟",
    region: "中国大陆",
    director: "谢君伟",
    actors: ["杨天翔", "凌振赫", "吴俊全"],
    description: "安史之乱后数年，吐蕃大军入侵西南，大唐节度使高适交战不利，长安岌岌可危。困守孤城的高适向监军太监回忆起自己与李白的一生往事。盛唐时代，才子辈出，诗酒风流，展现了一个繁荣昌盛又暗流涌动的大唐盛世。",
    tags: ["动画", "历史", "诗歌", "盛唐"],
    coverUrl: "https://readdy.ai/api/search-image?query=Animated%20film%20poster%20of%20Chang%20An%2C%20featuring%20ancient%20Chinese%20Tang%20Dynasty%20architecture%20with%20poetic%20ink%20wash%20painting%20style%2C%20golden%20sunset%20over%20classical%20pavilions%2C%20elegant%20Chinese%20calligraphy%20elements%2C%20cinematic%20lighting%2C%20rich%20cultural%20atmosphere%2C%20artistic%20composition%20with%20warm%20amber%20and%20crimson%20tones&width=400&height=560&seq=movie-cover-02&orientation=portrait",
    isHot: true,
    isNew: false,
    updateInfo: "HD高清",
    episodeTotal: 1,
    episodeCurrent: 1,
  },
  {
    id: 3,
    title: "封神第二部",
    englishTitle: "Creation of the Gods II",
    category: "电影",
    categorySlug: "movie",
    year: 2025,
    rating: 8.2,
    duration: "150分钟",
    region: "中国大陆",
    director: "乌尔善",
    actors: ["费翔", "李雪健", "黄渤"],
    description: "殷商末年，纣王暴虐无道，妖妃妲己祸乱朝纲。姜子牙携封神榜下山，辅佐西岐武王伐纣。太师闻仲率大军出征西岐，一场神魔大战即将爆发。各方势力明争暗斗，人、神、妖三方角力，天地为之变色。",
    tags: ["奇幻", "神话", "战争", "史诗"],
    coverUrl: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythology%20film%20poster%20for%20Creation%20of%20the%20Gods%2C%20featuring%20ancient%20warriors%20in%20ornate%20armor%20against%20a%20mystical%20battlefield%20with%20divine%20lightning%2C%20dramatic%20storm%20clouds%2C%20Chinese%20bronze%20age%20aesthetic%2C%20powerful%20composition%20with%20gold%20and%20crimson%20colors%2C%20cinematic%20fantasy%20atmosphere&width=400&height=560&seq=movie-cover-03&orientation=portrait",
    isHot: true,
    isNew: true,
    updateInfo: "HD高清",
    episodeTotal: 1,
    episodeCurrent: 1,
  },
  {
    id: 4,
    title: "暗夜追踪",
    englishTitle: "Night Pursuit",
    category: "电影",
    categorySlug: "movie",
    year: 2026,
    rating: 7.9,
    duration: "118分钟",
    region: "中国香港",
    director: "林超贤",
    actors: ["张家辉", "谢霆锋", "刘雅瑟"],
    description: "一名卧底警察在跨国毒品交易中身份暴露，被迫在限期48小时内找到关键证据自证清白。在暗夜笼罩的城市中，他必须在黑帮追杀和警方追捕的双重压力下，完成最后的任务。紧张刺激的都市追逐战，步步惊心的卧底生存法则。",
    tags: ["动作", "犯罪", "悬疑", "警匪"],
    coverUrl: "https://readdy.ai/api/search-image?query=Hong%20Kong%20crime%20thriller%20film%20poster%2C%20neon-lit%20rainy%20city%20streets%20at%20night%2C%20silhouette%20of%20a%20man%20running%20through%20dark%20alleys%2C%20dramatic%20blue%20and%20orange%20contrast%20lighting%2C%20film%20noir%20aesthetic%2C%20intense%20action%20atmosphere%2C%20modern%20urban%20hunter%20theme%20with%20cinematic%20grain&width=400&height=560&seq=movie-cover-04&orientation=portrait",
    isHot: true,
    isNew: true,
    updateInfo: "HD高清",
    episodeTotal: 1,
    episodeCurrent: 1,
  },
  {
    id: 5,
    title: "你好，李焕英2",
    englishTitle: "Hi, Mom 2",
    category: "电影",
    categorySlug: "movie",
    year: 2026,
    rating: 8.1,
    duration: "132分钟",
    region: "中国大陆",
    director: "贾玲",
    actors: ["贾玲", "张小斐", "沈腾"],
    description: "续集讲述了贾晓玲再次穿越时空，这一次她来到了母亲年轻时的80年代。在那个纯真年代，她见证了母亲与父亲相识相恋的全过程，也更深刻地理解了父母那一代人的青春与梦想。笑中带泪，温情满满的家庭喜剧。",
    tags: ["喜剧", "家庭", "穿越", "温情"],
    coverUrl: "https://readdy.ai/api/search-image?query=Heartwarming%20Chinese%20family%20comedy%20film%20poster%2C%201980s%20Chinese%20street%20scene%20with%20vintage%20bicycles%20and%20old%20shops%2C%20warm%20golden%20sunlight%2C%20mother%20and%20daughter%20embrace%20theme%2C%20retro%20Chinese%20aesthetics%2C%20soft%20nostalgic%20lighting%2C%20emotional%20and%20joyful%20atmosphere&width=400&height=560&seq=movie-cover-05&orientation=portrait",
    isHot: false,
    isNew: true,
    updateInfo: "HD高清",
    episodeTotal: 1,
    episodeCurrent: 1,
  },
  {
    id: 6,
    title: "深海危机",
    englishTitle: "Deep Sea Crisis",
    category: "电影",
    categorySlug: "movie",
    year: 2025,
    rating: 7.6,
    duration: "125分钟",
    region: "中国大陆",
    director: "陈思诚",
    actors: ["黄轩", "倪妮", "王传君"],
    description: "一艘深海科考潜艇在万米海沟失联，艇上六名科学家的生命危在旦夕。一支精英救援队奉命前往世界上最深的海域执行救援任务。然而深海中潜藏着未知的危险，救援行动变成了一场与时间赛跑的生死决战。",
    tags: ["灾难", "冒险", "科幻", "救援"],
    coverUrl: "https://readdy.ai/api/search-image?query=Deep%20sea%20disaster%20film%20poster%2C%20a%20submarine%20in%20dark%20abyssal%20ocean%20with%20bioluminescent%20creatures%2C%20beams%20of%20light%20piercing%20through%20water%2C%20intense%20survival%20atmosphere%2C%20deep%20blue%20and%20teal%20color%20palette%2C%20cinematic%20underwater%20photography%20style%20with%20dramatic%20tension&width=400&height=560&seq=movie-cover-06&orientation=portrait",
    isHot: false,
    isNew: false,
    updateInfo: "HD高清",
    episodeTotal: 1,
    episodeCurrent: 1,
  },
  {
    id: 7,
    title: "功夫熊猫5",
    englishTitle: "Kung Fu Panda 5",
    category: "电影",
    categorySlug: "movie",
    year: 2026,
    rating: 8.0,
    duration: "95分钟",
    region: "美国",
    director: "迈克·米切尔",
    actors: ["杰克·布莱克", "安吉丽娜·朱莉", "成龙"],
    description: "阿宝迎来了新的挑战——一位来自远古的邪恶武者意外苏醒，其强大的气功威胁着整个和平谷。阿宝必须集结新一代的功夫大师，学习失传已久的终极气功奥义，才能守护家园。充满中国元素的动画冒险大作。",
    tags: ["动画", "喜剧", "动作", "冒险"],
    coverUrl: "https://readdy.ai/api/search-image?query=Animated%20film%20poster%20for%20Kung%20Fu%20Panda%2C%20a%20panda%20in%20martial%20arts%20pose%20against%20a%20mystical%20Chinese%20mountain%20landscape%2C%20swirling%20energy%20and%20cherry%20blossoms%2C%20vibrant%20colors%20of%20gold%20jade%20and%20crimson%2C%20epic%20animated%20movie%20composition%2C%20joyful%20and%20adventurous%20feel&width=400&height=560&seq=movie-cover-07&orientation=portrait",
    isHot: true,
    isNew: false,
    updateInfo: "HD高清",
    episodeTotal: 1,
    episodeCurrent: 1,
  },
  {
    id: 8,
    title: "孤注一掷2",
    englishTitle: "No More Bets 2",
    category: "电影",
    categorySlug: "movie",
    year: 2026,
    rating: 8.3,
    duration: "140分钟",
    region: "中国大陆",
    director: "申奥",
    actors: ["张艺兴", "金晨", "王传君"],
    description: "续集聚焦于网络诈骗集团的新模式，一群高智商犯罪分子利用AI技术进行跨国电信诈骗。前作中的幸存者与警方合作，深入东南亚诈骗园区，与犯罪集团展开了一场高科技与人性较量的惊心动魄之战。",
    tags: ["犯罪", "悬疑", "剧情", "反诈"],
    coverUrl: "https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20film%20poster%2C%20modern%20tech%20surveillance%20theme%20with%20digital%20matrix%20elements%2C%20Southeast%20Asian%20urban%20backdrop%2C%20intense%20red%20and%20dark%20tones%2C%20cybersecurity%20atmosphere%2C%20sleek%20modern%20composition%20with%20human%20silhouette%2C%20dramatic%20tension&width=400&height=560&seq=movie-cover-08&orientation=portrait",
    isHot: false,
    isNew: true,
    updateInfo: "HD高清",
    episodeTotal: 1,
    episodeCurrent: 1,
  },
  {
    id: 9,
    title: "庆余年第二季",
    englishTitle: "Joy of Life Season 2",
    category: "电视剧",
    categorySlug: "tv",
    year: 2025,
    rating: 8.7,
    duration: "45分钟/集",
    region: "中国大陆",
    director: "孙皓",
    actors: ["张若昀", "李沁", "陈道明"],
    description: "范闲从北齐归来后，发现京都暗流涌动，各方势力蠢蠢欲动。二皇子与太子的储位之争愈发激烈，而幕后黑手的真实身份也逐渐浮出水面。范闲在权谋漩涡中步步为营，同时揭开母亲叶轻眉之死的真相。古装权谋巨制，高潮迭起。",
    tags: ["古装", "权谋", "武侠", "剧情"],
    coverUrl: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20series%20poster%2C%20elegant%20ancient%20Chinese%20palace%20with%20a%20scholar%20in%20flowing%20robes%2C%20ink%20wash%20painting%20style%20blended%20with%20cinematic%20lighting%2C%20jade%20and%20gold%20color%20palette%2C%20poetic%20atmosphere%2C%20Chinese%20aesthetic%20with%20dramatic%20royal%20court%20tension&width=400&height=560&seq=movie-cover-09&orientation=portrait",
    isHot: true,
    isNew: false,
    updateInfo: "更新至36集/全46集",
    episodeTotal: 46,
    episodeCurrent: 36,
  },
  {
    id: 10,
    title: "狂飙",
    englishTitle: "The Knockout",
    category: "电视剧",
    categorySlug: "tv",
    year: 2025,
    rating: 9.1,
    duration: "45分钟/集",
    region: "中国大陆",
    director: "徐纪周",
    actors: ["张译", "张颂文", "李一桐"],
    description: "以一线刑警安欣为代表的正义力量，与以高启强为首的黑恶势力展开了长达二十年的生死较量。故事横跨二十年，展现了扫黑除恶的艰辛历程，以及人性在欲望与正义之间的挣扎。年度现象级反黑题材电视剧。",
    tags: ["犯罪", "剧情", "反黑", "年代"],
    coverUrl: "https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%2C%20two%20men%20facing%20each%20other%20in%20dramatic%20tension%2C%20cityscape%20spanning%20two%20decades%20from%20old%20to%20modern%2C%20dark%20and%20moody%20atmosphere%20with%20selective%20warm%20highlights%2C%20film%20noir%20Chinese%20style%2C%20powerful%20emotional%20confrontation&width=400&height=560&seq=movie-cover-10&orientation=portrait",
    isHot: true,
    isNew: false,
    updateInfo: "全39集",
    episodeTotal: 39,
    episodeCurrent: 39,
  },
  {
    id: 11,
    title: "三体",
    englishTitle: "Three-Body",
    category: "电视剧",
    categorySlug: "tv",
    year: 2025,
    rating: 8.9,
    duration: "50分钟/集",
    region: "中国大陆",
    director: "杨磊",
    actors: ["张鲁一", "于和伟", "陈瑾"],
    description: "根据刘慈欣同名科幻小说改编。纳米科学家汪淼被卷入一场跨越星球的秘密战争，地球基础科学遭到未知力量封锁。随着调查深入，一个来自三体文明的神秘组织浮出水面，人类文明面临前所未有的威胁。硬核科幻巨制，细节精良。",
    tags: ["科幻", "悬疑", "剧情", "硬核科幻"],
    coverUrl: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%20based%20on%20Three-Body%20Problem%2C%20cosmic%20scale%20with%20three%20suns%20and%20a%20mysterious%20planet%2C%20scientific%20laboratory%20with%20glowing%20screens%2C%20deep%20space%20blue%20and%20amber%20contrast%2C%20mind-bending%20physics%20theme%2C%20atmospheric%20and%20intellectual%20aesthetic&width=400&height=560&seq=movie-cover-11&orientation=portrait",
    isHot: true,
    isNew: false,
    updateInfo: "全30集",
    episodeTotal: 30,
    episodeCurrent: 30,
  },
  {
    id: 12,
    title: "琅琊榜之风起长林",
    englishTitle: "Nirvana in Fire 2",
    category: "电视剧",
    categorySlug: "tv",
    year: 2026,
    rating: 8.4,
    duration: "45分钟/集",
    region: "中国大陆",
    director: "孔笙",
    actors: ["黄晓明", "刘昊然", "佟丽娅"],
    description: "故事发生在琅琊榜之后的数十年，大梁朝局再起波澜。长林王府功高震主，引来朝堂猜忌。长林世子萧平章与弟弟萧平旌继承父志，守护大梁北境。一场针对长林王府的阴谋悄然展开，兄弟二人面临生死抉择。",
    tags: ["古装", "权谋", "战争", "剧情"],
    coverUrl: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20series%20poster%2C%20two%20noble%20brothers%20in%20ancient%20military%20armor%20standing%20on%20a%20fortress%20wall%2C%20vast%20northern%20landscape%20with%20snow%20mountains%2C%20heroic%20atmosphere%20with%20Chinese%20banner%20flags%2C%20epic%20scale%2C%20jade%20and%20crimson%20color%20palette%2C%20poetic%20Chinese%20aesthetics&width=400&height=560&seq=movie-cover-12&orientation=portrait",
    isHot: false,
    isNew: true,
    updateInfo: "更新至28集/全50集",
    episodeTotal: 50,
    episodeCurrent: 28,
  },
  {
    id: 13,
    title: "乘风破浪的姐姐5",
    englishTitle: "Sisters Who Make Waves 5",
    category: "综艺",
    categorySlug: "variety",
    year: 2026,
    rating: 7.8,
    duration: "90分钟/期",
    region: "中国大陆",
    director: "",
    actors: ["宁静", "那英", "王心凌", "郑秀妍"],
    description: "30+姐姐们再次集结，开启全新的舞台竞演之旅。本季赛制全面升级，姐姐们将通过多轮公演舞台展示唱跳实力，争夺最终的成团席位。有欢笑有泪水，见证姐姐们突破自我的华丽蜕变。",
    tags: ["音乐", "竞演", "真人秀", "女性"],
    coverUrl: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20group%20of%20confident%20women%20in%20stylish%20modern%20outfits%20on%20a%20glamorous%20stage%20with%20spotlighting%2C%20golden%20and%20pink%20color%20palette%2C%20entertainment%20show%20atmosphere%2C%20dynamic%20energy%2C%20sparkling%20stage%20lights%2C%20fashion%20editorial%20style&width=400&height=560&seq=movie-cover-13&orientation=portrait",
    isHot: true,
    isNew: true,
    updateInfo: "更新至8期/全12期",
    episodeTotal: 12,
    episodeCurrent: 8,
  },
  {
    id: 14,
    title: "奔跑吧第十季",
    englishTitle: "Keep Running Season 10",
    category: "综艺",
    categorySlug: "variety",
    year: 2026,
    rating: 7.5,
    duration: "80分钟/期",
    region: "中国大陆",
    director: "",
    actors: ["李晨", "郑恺", "杨颖", "白鹿"],
    description: "国民综艺继续奔跑！全新一季跑男团将在全国各地展开趣味横生的游戏挑战。经典撕名牌环节回归，更有脑洞大开的新游戏等待解锁。欢乐与刺激并存，适合全家一起收看的综艺节目。",
    tags: ["游戏", "户外", "真人秀", "搞笑"],
    coverUrl: "https://readdy.ai/api/search-image?query=Chinese%20outdoor%20variety%20show%20poster%2C%20group%20of%20celebrities%20running%20and%20laughing%20in%20a%20colorful%20outdoor%20setting%2C%20bright%20and%20energetic%20atmosphere%2C%20blue%20sky%20and%20green%20field%20backdrop%2C%20fun%20competition%20theme%2C%20vibrant%20colors%2C%20joyful%20entertainment%20mood&width=400&height=560&seq=movie-cover-14&orientation=portrait",
    isHot: false,
    isNew: true,
    updateInfo: "更新至6期/全12期",
    episodeTotal: 12,
    episodeCurrent: 6,
  },
  {
    id: 15,
    title: "斗破苍穹",
    englishTitle: "Battle Through the Heavens",
    category: "动漫",
    categorySlug: "anime",
    year: 2026,
    rating: 8.3,
    duration: "20分钟/集",
    region: "中国大陆",
    director: "",
    actors: ["张沛", "赵爽", "赵路"],
    description: "天才少年萧炎在创造了家族空前绝后的修炼纪录后，突然变成了废人。种种打击接踵而至，就在他即将绝望之时，一缕灵魂从他手上的戒指里浮现，一扇全新的大门就此开启。热血玄幻国漫，特效炸裂。",
    tags: ["玄幻", "热血", "战斗", "冒险"],
    coverUrl: "https://readdy.ai/api/search-image?query=Chinese%20anime%20series%20poster%2C%20young%20warrior%20with%20mystical%20flames%20surrounding%20him%2C%20fantasy%20Chinese%20cultivation%20world%20with%20floating%20mountains%2C%20dynamic%20action%20pose%2C%20fiery%20orange%20and%20deep%20blue%20contrast%2C%20epic%20anime%20composition%2C%20powerful%20energy%20effects&width=400&height=560&seq=movie-cover-15&orientation=portrait",
    isHot: true,
    isNew: false,
    updateInfo: "更新至85集",
    episodeTotal: 104,
    episodeCurrent: 85,
  },
  {
    id: 16,
    title: "完美世界",
    englishTitle: "Perfect World",
    category: "动漫",
    categorySlug: "anime",
    year: 2026,
    rating: 8.6,
    duration: "22分钟/集",
    region: "中国大陆",
    director: "",
    actors: ["锦鲤", "刘明月", "李兰陵"],
    description: "一粒尘可填海，一根草斩尽日月星辰。群雄并起，万族林立，诸圣争霸。一个少年从大荒中走出，一切从这里开始。他立志成为至强者，守护所爱之人，一路披荆斩棘，登临绝巅。制作精良的国产3D动画。",
    tags: ["玄幻", "热血", "3D动画", "仙侠"],
    coverUrl: "https://readdy.ai/api/search-image?query=Chinese%203D%20anime%20series%20poster%2C%20a%20young%20hero%20standing%20on%20a%20cliff%20overlooking%20an%20ancient%20fantasy%20world%2C%20mythical%20beasts%20flying%20in%20the%20distance%2C%20cel-shaded%203D%20art%20style%2C%20epic%20fantasy%20landscape%20with%20Chinese%20aesthetic%2C%20gold%20and%20jade%20tones%2C%20cinematic%20wide%20shot&width=400&height=560&seq=movie-cover-16&orientation=portrait",
    isHot: true,
    isNew: false,
    updateInfo: "更新至132集",
    episodeTotal: 156,
    episodeCurrent: 132,
  },
  {
    id: 17,
    title: "舌尖上的中国第四季",
    englishTitle: "A Bite of China Season 4",
    category: "纪录片",
    categorySlug: "documentary",
    year: 2025,
    rating: 9.3,
    duration: "50分钟/集",
    region: "中国大陆",
    director: "陈晓卿",
    actors: [],
    description: "第四季将镜头对准了中国各地的街头美食与家庭厨房。从东北的酸菜炖粉条到广东的煲仔饭，从四川的麻辣火锅到新疆的烤全羊，每一道美食背后都是人与土地、人与人的温暖故事。用美食讲述中国人的生活哲学。",
    tags: ["美食", "文化", "人文", "纪实"],
    coverUrl: "https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%2C%20a%20stunning%20overhead%20shot%20of%20a%20traditional%20Chinese%20family%20dinner%20table%20filled%20with%20colorful%20authentic%20dishes%2C%20warm%20ambient%20lighting%2C%20steam%20rising%20from%20hot%20food%2C%20rustic%20wooden%20table%2C%20rich%20textures%20of%20various%20Chinese%20cuisine%2C%20heartwarming%20cultural%20atmosphere&width=400&height=560&seq=movie-cover-17&orientation=portrait",
    isHot: false,
    isNew: false,
    updateInfo: "全8集",
    episodeTotal: 8,
    episodeCurrent: 8,
  },
  {
    id: 18,
    title: "地球脉动第三季",
    englishTitle: "Planet Earth III",
    category: "纪录片",
    categorySlug: "documentary",
    year: 2025,
    rating: 9.7,
    duration: "60分钟/集",
    region: "英国",
    director: "",
    actors: [],
    description: "BBC自然纪录片巅峰之作。历时五年拍摄，足迹遍布全球43个国家。从深海到沙漠，从极地到热带雨林，呈现地球上最震撼的自然奇观和动物生存故事。每一帧都是壁纸级别的极致画质，大卫·爱登堡爵士倾情解说。",
    tags: ["自然", "动物", "地理", "BBC"],
    coverUrl: "https://readdy.ai/api/search-image?query=BBC%20nature%20documentary%20poster%2C%20breathtaking%20aerial%20view%20of%20Earth%20diverse%20landscapes%20merging%20together%2C%20from%20arctic%20ice%20to%20tropical%20rainforest%2C%20majestic%20wildlife%20silhouettes%2C%20cinematic%20natural%20lighting%2C%20epic%20scale%2C%20vivid%20greens%20and%20blues%2C%20Attenborough%20documentary%20aesthetic&width=400&height=560&seq=movie-cover-18&orientation=portrait",
    isHot: false,
    isNew: false,
    updateInfo: "全8集",
    episodeTotal: 8,
    episodeCurrent: 8,
  },
  {
    id: 19,
    title: "一念关山",
    englishTitle: "A Journey to Love",
    category: "电视剧",
    categorySlug: "tv",
    year: 2025,
    rating: 7.9,
    duration: "45分钟/集",
    region: "中国大陆",
    director: "周靖韬",
    actors: ["刘诗诗", "刘宇宁", "方逸伦"],
    description: "安国朱衣卫前左使任如意，因机缘巧合成为梧国迎帝使团队成员。她与梧国六道堂堂主宁远舟相识相知，在护送公主的路上共同经历生死考验。江湖儿女的恩怨情仇，朝廷内外的权力博弈，一幅江湖与庙堂交织的画卷。",
    tags: ["古装", "武侠", "爱情", "江湖"],
    coverUrl: "https://readdy.ai/api/search-image?query=Chinese%20wuxia%20romance%20drama%20poster%2C%20a%20swordsman%20and%20swordswoman%20in%20flowing%20ancient%20Chinese%20robes%20standing%20on%20a%20mountain%20peak%20at%20sunset%2C%20cherry%20blossoms%20in%20the%20wind%2C%20poetic%20martial%20arts%20atmosphere%2C%20warm%20amber%20and%20rose%20tones%2C%20elegant%20Chinese%20brush%20painting%20style&width=400&height=560&seq=movie-cover-19&orientation=portrait",
    isHot: false,
    isNew: false,
    updateInfo: "全40集",
    episodeTotal: 40,
    episodeCurrent: 40,
  },
  {
    id: 20,
    title: "熊出没·重启未来",
    englishTitle: "Boonie Bears: Restart the Future",
    category: "电影",
    categorySlug: "movie",
    year: 2026,
    rating: 7.8,
    duration: "105分钟",
    region: "中国大陆",
    director: "林汇达",
    actors: ["张伟", "张秉君", "谭笑"],
    description: "光头强和熊大熊二意外穿越到未来世界，发现地球已经被机器统治。为了回到过去拯救未来，他们必须联合未来的反抗力量，与机器军团展开对决。冒险中充满欢笑与感动，适合全家观看的国产动画大电影。",
    tags: ["动画", "喜剧", "冒险", "科幻"],
    coverUrl: "https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%20for%20Boonie%20Bears%2C%20two%20bears%20and%20a%20lumberjack%20in%20futuristic%20sci-fi%20setting%20with%20robots%2C%20colorful%20and%20family-friendly%20animated%20style%2C%20bright%20and%20cheerful%20atmosphere%2C%20sci-fi%20cityscape%20with%20Chinese%20elements%2C%20fun%20and%20adventurous%20mood&width=400&height=560&seq=movie-cover-20&orientation=portrait",
    isHot: false,
    isNew: true,
    updateInfo: "HD高清",
    episodeTotal: 1,
    episodeCurrent: 1,
  },
];

export const categories = [
  { name: "电影", slug: "movie", icon: "ri-film-line" },
  { name: "电视剧", slug: "tv", icon: "ri-tv-line" },
  { name: "综艺", slug: "variety", icon: "ri-movie-2-line" },
  { name: "动漫", slug: "anime", icon: "ri-robot-line" },
  { name: "纪录片", slug: "documentary", icon: "ri-earth-line" },
];